import { StrictMode, startTransition } from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
// Self-hosted fonts (bundled by Vite) instead of the render-blocking Google
// Fonts stylesheet — saves a third-party DNS/TLS round trip before first paint.
import '@fontsource-variable/fraunces/opsz.css'
import '@fontsource-variable/fraunces/opsz-italic.css'
import '@fontsource-variable/nunito/wght.css'
import '@fontsource/lato/300.css'
import '@fontsource/lato/400.css'
import '@fontsource/lato/700.css'
import './index.css'
import App from './App.jsx'

// The `js` / `reduce-motion` classes on <html> are set by an inline script in
// index.html, so prerendered markup paints in its final state before this runs.

const root = document.getElementById('root')
const app = (
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
)

// The home page ships prerendered (scripts/prerender.mjs) — attach to that
// markup instead of re-rendering it. Every other route gets the empty shell.
// Hydrating in a transition lets React yield to the browser every few ms
// instead of hydrating the whole page in one long task (Total Blocking Time).
if (root.hasChildNodes()) {
  startTransition(() => {
    hydrateRoot(root, app)
  })
} else {
  createRoot(root).render(app)
}
